<template>
    <div class="ls-out-of-market__container">
        <OutOfMarketLeadspediaForm />
    </div>
</template>

<script>
import VueScrollTo from 'vue-scrollto';
import * as types from '@/store/types';
import { mapState, mapActions, mapGetters } from 'vuex';
import eventBusService from '@/services/event-bus.service';
import OutOfMarketLeadspediaForm from '@/views/original-mydot/out-of-market-leadspedia/OutOfMarketLeadspediaForm.vue';
import brandMixin from '@/mixins/brand.mixin';

export default {
    components: {
        OutOfMarketLeadspediaForm,
    },
    mixins: [brandMixin],
    computed: {
        ...mapState(['manualRequest', 'contactInfo', 'screenSize', 'featureFlags']),
        ...mapGetters({
            desktop: types.SCREEN_SIZE__GET_DESKTOP_SCREEN,
        }),
        allStatesValid() {
            return this.manualRequest.valid && this.contactInfo.valid;
        },
    },
    methods: {
        ...mapActions({
            submitManualRequest: types.MANUAL_REQUEST__SUBMIT_MANUAL_REQUEST,
            registerExposure: types.FEATURE_FLAGS__REGISTER_EXPOSURE,
        }),
        submitOutOfMarketForm() {
            if (!this.allStatesValid) {
                eventBusService.eventBus.$emit('submitButtonClick');
                setTimeout(() => {
                    const firstInvalidInput =
                        document.getElementsByClassName('ls-manual-request--mq-invalid')[0] ||
                        document.getElementsByClassName('ls-invalid')[0] ||
                        null;
                    if (firstInvalidInput) {
                        const offset = this.screenSize.xs || this.screenSize.sm ? -150 : -105; // offset to account for the sticky header + the input label
                        VueScrollTo.scrollTo(firstInvalidInput, 500, { offset });
                    }
                });
            } else {
                this.submitManualRequest(this.$route);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.ls-out-of-market__container {
    margin-bottom: 100px; // scrolling to make bottom not feel like its getting cut off
}
</style>
